import {
  alpha,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const TableContainerStyled = styled(TableContainer)({
  maxHeight: 600,
  marginTop: 32,
});

export const TableHeadStyled = styled(TableHead)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
}));

export const TableRowStyled = styled(TableRow)(({ theme }) => ({
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: alpha(theme.palette.global.gray, 0.1),
  },
}));

export const TableCellHeaderStyled = styled(TableCell)(({ theme }) => ({
  color: theme.palette.global.white,
  fontWeight: 600,
  backgroundColor: theme.palette.primary.main,
}));

export const TableActionStyled = styled(TableCell)(({ theme }) => ({
  width: 100,
  '& button': {
    '& svg': {
      fontSize: 22,
      color: theme.palette.global.lightgray,
    },
    '&:hover': {
      '& svg': {
        color: theme.palette.secondary.main,
      },
      '& .delete': {
        color: '#ff0000',
      },
    },
  },
}));
